<template>
    <el-dialog class="dialog" :title="juesequanxianlisttitle" v-if="juesequanxianlist" :visible.sync="juesequanxianlist" width="80%" top="10vh">
        <!-- 工具栏 -->
        <div class="filter-container">
            <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" type="primary" @click="yonghuquanxianbtn">添加组成员</el-button>
            <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width: 220px"></el-input>
        </div>

        <!-- table 列表-->
        <el-table class="grayTableTile" size="mini"  v-loading="listLoading" :data="tableList" border style="width: 100%" @sort-change="handleAgeSortChange">
            <el-table-column prop="email" label="用户邮箱" sortable='custom'></el-table-column>
            <el-table-column prop="realname" label="用户姓名" sortable='custom'></el-table-column>
            <el-table-column prop="" label="操作" width="150">
                <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-danger" @click="quanxianshanchu(scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0;" />

    </el-dialog>
</template>

<script>
import Pagination from '@/components/Pagination'
import {groupinfo, userdoRemoveGroups} from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
export default {
    components: {Pagination},
    data() {
        return {
            juesequanxianlisttitle: '',
            juesequanxianlist: false,

            search: '',
            listLoading: false,
            originalCaseTable:[],// 排序原始数据
            caseTable: [], // 存放后端一次性返回的所有数据
            handCaseTable: [], // 存放处理假分页后的数据(等距切割)
            tableData: [], // 切割后页面应展示的数据
            total: 0,
            listQuery: {
               pageNo: 1,
               pageSize: 10 
            },

            userInfo: {}, // 详情
        }
    },

    computed: {
        tableList() {
            let caseTable = this.caseTable
            const search = this.search.toLowerCase().replace(/\s+/g,"");
            if(search) {
                caseTable = this.caseTable.filter(data => {
                return String(data['realname']).toLowerCase().indexOf(search) > -1 
                })
            }

            this.total = caseTable.length
            // 将一维数组切割成二维数组
            this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
            this.tableData = this.handCaseTable[this.listQuery.pageNo-1]
            return this.tableData
        }
    },

    methods: {
        init(row) {
            this.juesequanxianlisttitle = "分组用户详情：" + row.desc // 标题
            this.juesequanxianlist = true
            this.userInfo = row
            this.search = ''
            this.listLoading = false
            this.tableData = []
            this.total = 0
            this.listQuery = {
               pageNo: 1,
               pageSize: 10 
            }

            this.getList(row)
        },

        // 获取列表
        getList(row) {
            this.listLoading = true
            groupinfo(row.id).then(response => {
                this.listLoading = false;
                if (response.code == 1) {
                    this.caseTable = response.data.users;
                    this.originalCaseTable = JSON.parse(JSON.stringify(this.caseTable))
                }
            });
        },

        // 排序
        handleAgeSortChange(e) {
            if(e.order) {
                const order = e.order == 'descending' ? false : true
                this.caseTable.sort(sortKeys(e.prop, order))
            } else {
                this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
            }
        },

        // 单个删除
        quanxianshanchu(row) {
            const data = {
                groupId : [this.userInfo.id],
                userId : [row.id]
            }
            this.$confirm('确认删除用户：' + row.realname + '" 吗？').then(_ => {
                userdoRemoveGroups(data).then(response => {
                    if (response.code == 1) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.getList(this.userInfo)
                    }
                });
            }).catch(_ => { });
        },

        // 添加组成员
        yonghuquanxianbtn() {
            this.$emit('handleAddGroups', this.userInfo)
        },
    }
}
</script>